// export const BASE_URL = 'http://localhost:8000';
// export const GQL_URL = 'http://localhost:8000/graphql'
// export const WEB_SOCKET_URL = 'ws://localhost:8000/graphql'

export const BASE_URL = "https://api.cvdmart.com";
export const GQL_URL = "https://api.cvdmart.com/graphql";
export const WEB_SOCKET_URL = "wss://api.cvdmart.com/graphql";
